export const GRAPH_FACETS = {
  dataslug: { type: "terms", field: "dataslug", limit: -1, mincount: 1 },

  // terms
  occupation: { type: "terms", field: "Occupation", limit: 100, mincount: 1 },
  birthLocation: { type: "terms", field: "birthLocation", limit: 100, mincount: 1 },
  deathLocation: { type: "terms", field: "deathLocation", limit: 100, mincount: 1 },

  // ranges: dates + years
  birthDate_min: "min(birthDate)",
  birthDate_max: "max(birthDate)",
  deathDate_min: "min(deathDate)",
  deathDate_max: "max(deathDate)",

  birthYear_min: "min(birthYear)",
  birthYear_max: "max(birthYear)",
  deathYear_min: "min(deathYear)",
  deathYear_max: "max(deathYear)",

  // exists: Abstract / Publication
  exists_abstract_has: { type: "query", q: "Abstract:[* TO *]" },
  exists_abstract_missing: { type: "query", q: "-Abstract:[* TO *]" },

  exists_publication_has: { type: "query", q: "Publication:[* TO *]" },
  exists_publication_missing: { type: "query", q: "-Publication:[* TO *]" },
};
